export const DisplayStatusState = {
  Normal: 0,
  OK: 1,
  Warning: 2,
  Error: 3,
  Fatal: 4,
  Emphasis: 5,
} as const;
